import ToastProvider, { ToastOptions } from '@carvana/showroom-toast';
import React, { createContext } from 'react';

type AlertContextType = {
  showToast: (opt: ToastOptions) => void;
};

const AlertsContext = createContext<AlertContextType>({
  showToast: () => {}
});

export function AlertsContextProvider({
  children
}: React.PropsWithChildren<{}>) {
  return (
    <ToastProvider
      render={({ showToast }) => (
        <AlertsContext.Provider value={{ showToast }}>
          {children}
        </AlertsContext.Provider>
      )}
    />
  );
}

AlertsContextProvider.displayName = 'AlertsContextProvider';

export default AlertsContext;
